var render = function render(){var _vm=this,_c=_vm._self._c;return _c('stzh-header',{staticClass:"stzh-header",attrs:{"hide-metabar":_vm.hideMetabar,"sticky":_vm.sticky}},[_c('img',{attrs:{"slot":"logo","src":"https://www.stadt-zuerich.ch/content/dam/corporate-design/de/logos/stadt-zuerich.svg","alt":"Logo City Zürich, go to homepage"},slot:"logo"})])
}
var staticRenderFns = []

export { render, staticRenderFns }